import PermitsPage from "./permits";

export default PermitsPage;